









import Vue from "vue";

export default Vue.extend({
    name: "SkeletonBox",
    props: {
        width: {
            type: String,
            required: false,
            default: ""
        },
        height: {
            type: String,
            required: false,
            default: ""
        },
        variant: {
            type: String,
            required: false,
            default: "",
            validator: function(value: string): boolean {
                return ["", "circle", "rounded", "text", "title", "subtitle", "image", "button", "toggle", "badge"].includes(value);
            }
        }
    },
    computed: {
        skeletonClasses: function(): Record<string, boolean> {
            return {
                ["skeleton--" + this.variant]: this.variant !== ""
            };
        },
        computedStyle: function(): Record<string, string> {
            const style: Record<string, string> = {};
            if (this.width) {
                style.width = this.width;
            }
            if (this.height) {
                style.height = this.height;
            }
            return style;
        }
    }
});
